module.exports = __webpack_public_path__ + "img/companion-logo.a580d339.png";